import type { FC } from "react";
import React from "react";
import { Flex } from "@edreamsodigeo/prisma-design-system";

import type { LightboxOfferSubscriptionsProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/contracts";
import { BgWrapperColor } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/contracts";
import { LightboxOfferSubscriptionsPopover } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/LightboxOfferSubscriptions/LightboxOfferSubscriptionsPopover";
import { LightboxOfferSubscriptionWrapper } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/LightboxOfferSubscriptions/LightboxOfferSubscriptionWrapper";
import { LightboxOfferSubscriptionSingle } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/LightboxOfferSubscriptions/LightboxOfferSubscriptionSingle";

const LightboxOfferSubscriptionsDesktop: FC<
  LightboxOfferSubscriptionsProps
> = ({ basicOffer, plusOffer, freeTrialDays, text }) => {
  const isBasicOfferVisible =
    !!basicOffer &&
    !!basicOffer?.renewalPrice.currency &&
    !!basicOffer?.renewalPrice.amount;
  const isPlusOfferVisible =
    !!plusOffer &&
    !!plusOffer?.renewalPrice.currency &&
    !!plusOffer?.renewalPrice.amount;

  return (
    <Flex
      justifyContent={"space-between"}
      mr={"1x_small"}
      sx={{ minWidth: "278px" }}
    >
      {isBasicOfferVisible && (
        <LightboxOfferSubscriptionWrapper color={BgWrapperColor.BASIC}>
          <LightboxOfferSubscriptionSingle
            offer={basicOffer}
            text={text.textBasic}
          />
        </LightboxOfferSubscriptionWrapper>
      )}
      {isPlusOfferVisible && (
        <LightboxOfferSubscriptionsPopover freeTrialDays={freeTrialDays}>
          <LightboxOfferSubscriptionSingle
            offer={plusOffer}
            text={text.textPlus}
          />
        </LightboxOfferSubscriptionsPopover>
      )}
    </Flex>
  );
};

export default LightboxOfferSubscriptionsDesktop;
